import { render, staticRenderFns } from "./jcQdList.vue?vue&type=template&id=5137ce12&"
import script from "./jcQdList.vue?vue&type=script&lang=js&"
export * from "./jcQdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports